import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RedirectLinkPagesComponent } from './redirect-link-pages.component';
import { CommonsModule } from '../../commons/commons.module';

@NgModule({
  declarations: [RedirectLinkPagesComponent],
  imports: [CommonModule, CommonsModule],
})
export class RedirectLinkPagesModule {}
